module.exports = __webpack_public_path__ + "static/m_solution15-81304f422cc12a119fb1abb667e125d8.png";